import React, { useEffect } from 'react';
import { SocialIcon } from 'react-social-icons';
import logo from '../../images/my-bg.png'
import Aos from 'aos';
import 'aos/dist/aos.css';

const About = () => {
    useEffect(() => {
        Aos.init()
    })
    
    return (
        <div
        data-aos="fade-up"
     data-aos-duration="3000"
    
        className="grid lg:grid-cols-2 px-20 bg-gray-300 pb-20">


            <div>
            <img width="500" src={logo} alt="" />
            </div>

            <div>
                <h1 className="text-4xl text-justify text-bold text-red-500">About Me</h1>
                
        <p className="text-xl font-medium text-justify ">I am a MERN-Stack WEB Developer. I am working with React, Node.js and MongoDB. I also have experience in developing static websites using HTML5, CSS3 and JavaScript (ES6). I am a quick learner. I believe in hard work and efficiency. That's why I am always ready to accomplish any task by working hard. I always focus on learning new technology. My goal is to become A World-Class Professional Web Developer.</p>
        <h2 className="text-2xl text-justify text-semibold text-red-500 mt-4">
        Here are a few technologies I've been working with recently :
        </h2>
        <hr className=" bg-gray-500" />
        <div className="text-justify  font-semibold">
           <div 
            data-aos-duration="3000"
            data-aos="flip-right"
           className="grid lg:grid-cols-3"> 
           <div>
            <h2 className="text-xl text-red-600">Frontend </h2>
            
            <li>JavaScript (ES6)</li>
            <li>React.js</li>
            <li>Redux</li>
            <li>React</li>
            <li> Bootstrap</li>
            <li> HTML5</li>
            <li>CSS3</li>
            <li>Material UI</li>
            </div>
            


            <div>
            <h2 className="text-xl text-red-600"> Backend</h2>
            <li>Node.js</li>
            <li>Express.js</li>
            <li>MongoDB</li>
            </div>


            <div>
            <h2 className="text-xl text-red-600">Tools</h2>
            <li> VS Code</li>
            <li>Git</li>
            <li>Chrome Dev Tool</li>
            <li>Npm & Yarn</li>
            <li>Firebase</li>
            <li>Netlify </li>
            <li> Heroku</li>
            </div>
           </div>
           <div 
           data-aos="zoom-out-up"
           data-aos-duration="3000"
           className="mt-5 pb-10">
            <SocialIcon url="https://www.linkedin.com/in/joy10311/" />
            <SocialIcon className=" mx-10" url="https://web.facebook.com/enjoy0069" />
            <SocialIcon  url="https://github.com/Joy10311" />
            <SocialIcon className=" mx-10" network="email" url="joy10311@gmail.com" />

            </div>
        </div>
            </div>
            
           
        </div>
    );
};

export default About;